
import { defineComponent, onMounted, computed, PropType } from 'vue'
import { useForm } from 'vee-validate'
import { object } from 'yup'
import { myValidationSchemaObj, validationMessage } from '@/views/validation'
import { TanpokenUiItem } from '@/views/fuzoku-meisai/junsoku/data'
import NumberWithComma from '@/views/components/NumberWithComma.vue'

type InputForm = {
  itemName: string;
  kimatsuTyouboKakaku: number;
  tanpokenShurui: string;
  saimuNaiyou: string;
  kimatsuSaimuZandaka: number;
}

const validationSchema = object({
  itemName: myValidationSchemaObj.maxString(20),
  kimatsuTyouboKakaku: myValidationSchemaObj.requiredPositiveNum,
  tanpokenShurui: myValidationSchemaObj.maxString(100),
  saimuNaiyou: myValidationSchemaObj.maxString(100),
  kimatsuSaimuZandaka: myValidationSchemaObj.requiredPositiveNum
})

export default defineComponent({
  components: { NumberWithComma },
  props: {
    item: {
      type: Object as PropType<TanpokenUiItem>,
      required: true
    },
    isFirst: {
      type: Boolean,
      required: false,
      default: false
    },
    isLast: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: {
    upItem: (item: TanpokenUiItem) => true,
    downItem: (item: TanpokenUiItem) => true,
    trashItem: (item: TanpokenUiItem) => true,
    changeInput: (item: TanpokenUiItem) => true
  },
  setup (props, { emit }) {
    const { errors, values, validate, meta } = useForm<InputForm>({
      validationSchema: validationSchema,
      initialValues: {
        itemName: props.item.item.itemName,
        kimatsuTyouboKakaku: props.item.item.kimatsuTyouboKakaku,
        tanpokenShurui: props.item.item.tanpokenShurui,
        saimuNaiyou: props.item.item.saimuNaiyou,
        kimatsuSaimuZandaka: props.item.item.kimatsuSaimuZandaka
      }
    })

    onMounted(async () => {
      await validate()
      const item = props.item
      item.isValid = meta.value.valid
      emit('changeInput', item)
    })

    const headerName = computed(() => {
      if (!values.itemName) {
        return validationMessage.enterItem
      }
      return values.itemName
    })

    const onClickedUpItem = () => {
      emit('upItem', props.item)
    }

    const onClickedDownItem = () => {
      emit('downItem', props.item)
    }

    const onClickedTrashItem = () => {
      emit('trashItem', props.item)
    }

    const onChangeInput = async () => {
      const item = props.item
      item.item.itemName = values.itemName
      item.item.kimatsuTyouboKakaku = values.kimatsuTyouboKakaku
      item.item.tanpokenShurui = values.tanpokenShurui
      item.item.saimuNaiyou = values.saimuNaiyou
      item.item.kimatsuSaimuZandaka = values.kimatsuSaimuZandaka
      await validate()
      item.isValid = meta.value.valid
      emit('changeInput', props.item)
    }

    return {
      headerName,
      errors,
      values,
      validate,
      onChangeInput,
      onClickedUpItem,
      onClickedDownItem,
      onClickedTrashItem
    }
  }
})
